import theme from '@theme';
import React from 'react';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';

import { Action, DisplayHeader } from '../display-form';
import DisplaySection from './DisplaySection';
import { copyOrderDetails, exportOrderDetailsToExcel } from './functions';
import { ConfigOrderDetails } from './types';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '../../../../locales/constants/translationNamespaces.enum';

const OrderDetails: React.FC<ConfigOrderDetails> = (configOrderDetails) => {
  const { t } = useTranslation(TranslationNamespaces.SITE_STATUS);
  const { header, sections } = configOrderDetails;

  const copyActions = () => {
    copyOrderDetails(configOrderDetails);
  };

  const exportToExcel = () => {
    exportOrderDetailsToExcel(configOrderDetails);
  };

  const actions: Action[] = [
    {
      label: t('orderDetails.utils.copy'),
      callback: copyActions,
      iconName: 'duplicate'
    },
    {
      label: t('orderDetails.utils.export'),
      callback: exportToExcel,
      iconName: 'export'
    }
  ];

  return (
    <Col>
      <OrderDetailsContainer>
        {header.custom ?? (
          <DisplayHeader
            name={header.name}
            elements={header.headerBadges ?? []}
            actions={actions}
          />
        )}
        {sections.map((section) => (
          <DisplaySection key={section.title} {...section} />
        ))}
      </OrderDetailsContainer>
    </Col>
  );
};

const OrderDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-left: 1rem;
  border-left-width: 1px;
  border-right-width: 0px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-color: ${theme.palette.grey[100]};
  border-style: solid;
`;

export default OrderDetails;
